import React, { useState, useEffect, useMemo } from "react";
import "./App.css";
import Sidebar from "./components/Sidebar";
import VideoPlayer from "./components/VideoPlayer";
import introGif1 from "./assets/intro1.gif";
import introGif2 from "./assets/intro2.gif";
import kickLogo from "./assets/kick.svg";
import twitchLogo from "./assets/twitch.png";

const API_KEY = "AIzaSyAM9NvQakX2YG3CGWCZLEo20C1W7NcZ4tg";
const PLAYLIST_ID_KICK = "PLPxByEV3eGJPz913RMJTPBjM7W9QzigtS";
const PLAYLIST_ID_TWITCH = "PLzG3PbeIsElPhuNzKLW_JCeRQ4sNBQCWk";

function parseDuration(isoDuration) {
  const match = isoDuration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  const hours = match[1] ? parseInt(match[1]) : 0;
  const minutes = match[2] ? parseInt(match[2]) : 0;
  const seconds = match[3] ? parseInt(match[3]) : 0;
  const h = hours > 0 ? `${hours}:` : "";
  const m = hours > 0 && minutes < 10 ? `0${minutes}` : `${minutes}`;
  const s = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return `${h}${m}:${s}`;
}

// Function to parse ISO duration to hours for calculations
function parseIsoDurationToHours(isoDuration) {
  const match = isoDuration.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
  const hours = match[1] ? parseInt(match[1]) : 0;
  const minutes = match[2] ? parseInt(match[2]) : 0;
  const seconds = match[3] ? parseInt(match[3]) : 0;
  return hours + minutes / 60 + seconds / 3600;
}

// Function to extract episode and part number from WIRED ZİNCİRSİZ titles
function extractEpisodeInfo(title) {
  // Matches titles like "🟢WIRED ZİNCİRSİZ #41" and "🟢WIRED ZİNCİRSİZ #41-2"
  const match = title.match(/🟢WIRED\s+ZİNCİRSİZ\s+#(\d+)(?:-(\d+))?/i);
  if (!match) return null;

  return {
    episode: parseInt(match[1], 10),
    part: match[2] ? parseInt(match[2], 10) : 1, // base episode is part 1
  };
}

// Mobile detection hook
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

const games = [
  {
    name: "Magic: The Gathering Arena",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co1l8n.jpg",
    link: "https://backloggd.com/games/magic-the-gathering-arena/",
    sessions: [
      { id: "L3yOfRJv0Yc", time: 18890, label: "#39 (5:14:50)" },
      { id: "iOJCSLCouz8", time: 10377, label: "#49 (2:52:57)" },
      { id: "GywnGlAbQQI", time: 13785, label: "#79 (3:49:45)" },
      { id: "xLMM4RakSyg", time: 16834, label: "#82 (5:34:30)" },
      { id: "pIHKc9WNehA", time: 12868, label: "#107 (3:34:28)" },
      { id: "RbwD8-tf4vc", time: 15257, label: "#109 (4:14:36)" },
      { id: "194ojRgnBwg", time: 4098, label: "#114 (1:08:18)" },
      { id: "gafmRxBkanA", time: 1201, label: "#115 (0:20:01)" },
      { id: "UuLBwW8iVYg", time: 10526, label: "#116 (2:55:26)" },
      { id: "khBU2csDVME", time: 21702, label: "#117 (6:01:43)" },
      { id: "EuzjGO0L65o", time: 1198, label: "#117-2 (19:58)" },
      { id: "EuzjGO0L65o", time: 8624, label: "#117-2 (2:23:44)" },
      { id: "H962Icu2v8Y", time: 22775, label: "#118 (6:19:35)" },
      { id: "derNOzbiVo4", time: 19304, label: "#119 (5:21:44)" },
      { id: "oIRyclbHlJ4", time: 18154, label: "#119-2 (5:02:34)" },
      { id: "9DEfiaahXHQ", time: 7367, label: "#120 (2:02:47)" },
      { id: "P5RSNmSy9oQ", time: 10344, label: "#121 (2:42:24)" },
      { id: "3a8FLrK8MLg", time: 19760, label: "#122 (5:29:20)" },
      { id: "j9cqVoSqbpU", time: 21783, label: "#123 (6:03:03)" },
      { id: "wMQ6tCPQN84", time: 891, label: "#124 (14:51)" },
      { id: "6hdY68VD9RE", time: 1265, label: "#141 (21:05)" },
    ],
  },
  {
    name: "Space Station 13",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co1of6.jpg",
    link: "https://backloggd.com/games/space-station-13/",
    sessions: [
      { id: "qIKAJiYRp4s", time: 10980, label: "#40 (3:05:00)" },
      { id: "hwzf4K5oOwE", time: 6326, label: "#41 (1:45:25)" },
      { id: "b_O1TdxGJx8", time: 7447, label: "#42 (2:04:07)" },
      { id: "5A9xsN5LBqk", time: 6345, label: "#93 (1:45:45)" },
      { id: "3a8FLrK8MLg", time: 2101, label: "#122 (35:01)" },
      { id: "C9tnBw8Bfs4", time: 1129, label: "#144 (18:49)" },
      { id: "BGUu_pW7f1E", time: 593, label: "#145 (9:53)" },
    ],
  },
  {
    name: "Star Wars Outlaws",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9nh7.jpg",
    link: "https://backloggd.com/games/star-wars-outlaws/",
    sessions: [
      { id: "b_O1TdxGJx8", time: 19461, label: "#42 (5:24:21)" },
      { id: "usokuCzK9cw", time: 90, label: "#174 (1:30)" },
    ],
  },
  {
    name: "The Legend of Zelda: Tears of the Kingdom",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co5vmg.jpg",
    link: "https://backloggd.com/games/the-legend-of-zelda-tears-of-the-kingdom/",
    sessions: [
      { id: "b_O1TdxGJx8", time: 25874, label: "#42 (7:11:14)" },
      { id: "ANzWKiDvP_o", time: 15535, label: "#43 (4:18:55)" },
      { id: "dINspdkE5Ag", time: 3660, label: "#44 (1:01:00)" },
      { id: "WF8mF_hB1SY", time: 3864, label: "#45 (1:04:24)" },
    ],
  },
  {
    name: "Obenseuer",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co6pr5.jpg",
    link: "https://backloggd.com/games/obenseuer/",
    sessions: [
      { id: "ANzWKiDvP_o", time: 10170, label: "#43 (2:49:30)" },
    ],
  },
  {
    name: "Do Not Feed the Monkeys",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co28xk.jpg",
    link: "https://backloggd.com/games/do-not-feed-the-monkeys/",
    sessions: [
      { id: "EfLo42Q7MIg", time: 15275, label: "#46 (4:14:35)" },
      { id: "sQ5OD2tULjQ", time: 14695, label: "#63 (4:04:55)" },
    ],
  },
  {
    name: "Metaphor: ReFantazio",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8d9t.jpg",
    link: "https://backloggd.com/games/metaphor-refantazio/",
    sessions: [
      { id: "Lgl4Vx2v6f8", time: 6801, label: "#47 (1:53:21)" },
      { id: "D-hPJDguSZM", time: 2138, label: "#55 (35:39)" },
      { id: "ErFUjaFarSM", time: 15515, label: "#56 (4:18:35)" },
      { id: "pBznaLSLuQw", time: 6480, label: "#158 (1:48:00)" },
    ],
  },
  {
    name: "The Legend of Zelda: Echoes of Wisdom",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8d9b.jpg",
    link: "https://backloggd.com/games/the-legend-of-zelda-echoes-of-wisdom/",
    sessions: [
      { id: "Pa3w02eWNOg", time: 14082, label: "#48 (3:54:42)" },
    ],
  },
  {
    name: "Silent Hill 2",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co5l7s.jpg",
    link: "https://backloggd.com/games/silent-hill-2--1/",
    sessions: [
      { id: "sZwGOg165J0", time: 12115, label: "#51 (3:21:55)" },
      { id: "-o12iMxUp-Q", time: 13781, label: "#52 (3:49:41)" },
    ],
  },
  {
    name: "TCG Card Shop Simulator",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8o8l.jpg",
    link: "https://backloggd.com/games/tcg-card-shop-simulator/",
    sessions: [
      { id: "-o12iMxUp-Q", time: 4220, label: "#52 (1:10:20)" },
    ],
  },
  {
    name: "Yakuza: Like a Dragon",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2em9.jpg",
    link: "https://backloggd.com/games/yakuza-like-a-dragon/",
    sessions: [
      { id: "ErFUjaFarSM", time: 23484, label: "#56 (6:31:24)" },
      { id: "TWT0xM4xzrw", time: 12715, label: "#59 (3:31:55)" },
      { id: "gUK69id7lFs", time: 23877, label: "#60 (6:37:57)" },
    ],
  },
  {
    name: "Dragon Age: Inquisition",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2mvy.jpg",
    link: "https://backloggd.com/games/dragon-age-inquisition/",
    sessions: [
      { id: "PZDYL3akMbg", time: 2213, label: "#57 (36:53)" },
    ],
  },
  {
    name: "Signalis",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co62ig.jpg",
    link: "https://backloggd.com/games/signalis/",
    sessions: [
      { id: "PZDYL3akMbg", time: 16138, label: "#57 (4:28:58)" },
      { id: "AJNFRLuEy9o", time: 5175, label: "#58-59(1:26:15)" },
    ],
  },
  {
    name: "S.T.A.L.K.E.R. 2: Heart of Chornobyl",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co5pxn.jpg",
    link: "https://backloggd.com/games/stalker-2-heart-of-chornobyl/",
    sessions: [
      { id: "gUK69id7lFs", time: 1171, label: "#60 (19:31)" },
      { id: "nt0gnWPdSOM", time: 17041, label: "#62 (4:44:01)" },
    ],
  },
  {
    name: "Final Fantasy XIV Online",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co48rz.jpg",
    link: "https://backloggd.com/games/final-fantasy-xiv-online--1/",
    sessions: [
      { id: "Qm3jqMwL4wI", time: 13259, label: "#65 (3:40:59)" },
      { id: "529MoVQCnIg", time: 21948, label: "#67 (6:05:48)" },
      { id: "tTmQ11GzDsQ", time: 15010, label: "#68 (4:10:10)" },
      { id: "_5tXNQJY2Ak", time: 20128, label: "#69 (5:35:28)" },
      { id: "pkmoC-g2IFo", time: 4947, label: "#70 (1:22:27)" },
      { id: "1YnkHqBFKfU", time: 13045, label: "#72 (3:37:27)" },
      { id: "zjFTbvxYxaU", time: 12817, label: "#73 (3:38:37)" },
      { id: "4JZYDB8xbr0", time: 4973, label: "#74 (1:22:53)" },
      { id: "y2zG2GTYuzU", time: 11806, label: "#76 (3:16:46)" },
      { id: "mQEZLBnjVYY", time: 14114, label: "#129 (3:55:14)" },
      { id: "X6tQqE8y2Ck", time: 15755, label: "#130 (4:22:35)" },
      { id: "cyZfFzH8fQA", time: 6729, label: "#131 (1:52:09)" },
      { id: "rBUBc94Pc-s", time: 18817, label: "#132 (5:13:37)" },
      { id: "G7G4lrWbQto", time: 36439, label: "#133 (10:07:20)" },
      { id: "uffaL0r9-fE", time: 13758, label: "#135 (3:49:18)" },
    ],
  },
  {
    name: "Dwarf Fortress",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co5v53.jpg",
    link: "https://backloggd.com/games/dwarf-fortress--1/",
    sessions: [
      { id: "pkmoC-g2IFo", time: 7222, label: "#70 (2:00:22)" },
      { id: "M9LgCStNlBY", time: 1619, label: "#71 (26:59)" },
      { id: "1YnkHqBFKfU", time: 20461, label: "#72 (5:41:59)" },
      { id: "y2zG2GTYuzU", time: 19969, label: "#76 (5:32:49)" },
      { id: "BGdV96EvuQg", time: 11829, label: "#77 (3:17:09)" },
      { id: "ebQqUmNNars", time: 12593, label: "#163 (3:29:53)" },
      { id: "TM1cPivDtWc", time: 9019, label: "#164 (2:30:19)" },
      { id: "OpnJTOCc45E", time: 9850, label: "#165 (2:44:10)" },
      { id: "LPYH9SyelYE", time: 12481, label: "#166 (3:28:01)" },
    ],
  },
  {
    name: "Gran Turismo 7",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2g84.jpg",
    link: "https://backloggd.com/games/gran-turismo-7/",
    sessions: [
      { id: "zjFTbvxYxaU", time: 24841, label: "#73 (6:53:01)" },
      { id: "4JZYDB8xbr0", time: 21885, label: "#74 (6:04:45)" },
    ],
  },
  {
    name: "Marvel Rivals",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coa43r.jpg",
    link: "https://backloggd.com/games/marvel-rivals/",
    sessions: [
      { id: "4JZYDB8xbr0", time: 11501, label: "#74 (3:11:41)" },
    ],
  },
  {
    name: "Lorn's Lure",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8ugv.jpg",
    link: "https://backloggd.com/games/lorns-lure/",
    sessions: [
      { id: "BGdV96EvuQg", time: 1635, label: "#77 (27:15)" },
    ],
  },
  {
    name: "Kingdom Come: Deliverance II",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8qmv.jpg",
    link: "https://backloggd.com/games/kingdom-come-deliverance-ii/",
    sessions: [
      { id: "yTEW3XZeB3M", time: 2137, label: "#78 (35:37)" },
      { id: "GywnGlAbQQI", time: 17040, label: "#79 (4:44:00)" },
      { id: "OikNB6AwZfE", time: 15983, label: "#80 (4:26:23)" },
      { id: "aoxRHgTbQt0", time: 19764, label: "#81 (5:29:24)" },
    ],
  },
  {
    name: "Dota 2",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co6ene.jpg",
    link: "https://backloggd.com/games/dota-2/",
    sessions: [
      { id: "OikNB6AwZfE", time: 9462, label: "#80 (2:37:42)" },
    ],
  },
  {
    name: "I'm on Observation Duty",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2u72.jpg",
    link: "https://backloggd.com/games/im-on-observation-duty/",
    sessions: [
      { id: "xLMM4RakSyg", time: 16834, label: "#82 (4:40:36)" },
    ],
  },
  {
    name: "Voices of the Void",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8uks.jpg",
    link: "https://backloggd.com/games/voices-of-the-void--1/",
    sessions: [
      { id: "HRFAMkrTNAo", time: 12080, label: "#83 (3:21:20)" },
      { id: "wy9VmyI4d1s", time: 8542, label: "#92 (2:22:22)" },
      { id: "3uqBNFLn7qk", time: 13269, label: "#147 (3:41:10)" },
      { id: "Gclmhdo8LvE", time: 12522, label: "#148 (3:28:43)" },
      { id: "xxYlplJs1Fs", time: 8738, label: "#149 (2:25:38)" },
      { id: "0C-vegozioY", time: 7379, label: "#151 (2:03:01)" },
      { id: "Vm5YOXXccjI", time: 12424, label: "#156 (3:27:04)" },
    ],
  },
  {
    name: "Returnal",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co3wc1.jpg",
    link: "https://backloggd.com/games/returnal/",
    sessions: [
      { id: "5A9xsN5LBqk", time: 3060, label: "#93 (51:00)" },
    ],
  },
  {
    name: "Trans-Siberian Railway Simulator",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co2ley.jpg",
    link: "https://backloggd.com/games/trans-siberian-railway-simulator/",
    sessions: [
      { id: "Yr1oRhTXQVM", time: 10818, label: "#94 (3:00:18)" },
      { id: "9Ia-YdTKcZ0", time: 11582, label: "#95 (3:13:02)" },
    ],
  },
  {
    name: "Kenshi",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co4a29.jpg",
    link: "https://backloggd.com/games/kenshi/",
    sessions: [
      { id: "I-MzmaEmv0w", time: 1253, label: "#98 (20:53)" },
      { id: "WrqEmFTQTOs", time: 6825, label: "#99 (1:53:45)" },
      { id: "TykZhI8eFfw", time: 8868, label: "#100 (2:27:48)" },
    ],
  },
  {
    name: "Fortnite",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coa0g0.jpg",
    link: "https://backloggd.com/games/fortnite/",
    sessions: [
      { id: "pyofSHPEH7A", time: 5141, label: "#101 (1:25:41)" },
      { id: "6bSzZQJET0E", time: 3869, label: "#102 (1:04:29)" },
      { id: "RbwD8-tf4vc", time: 9763, label: "#109 (2:42:43)" },
      { id: "oIRyclbHlJ4", time: 10625, label: "#119 (2:57:05)" },
      { id: "9DEfiaahXHQ", time: 4184, label: "#120 (1:09:44)" },
      { id: "X6tQqE8y2Ck", time: 2317, label: "#130 (38:37)" },
      { id: "G7G4lrWbQto", time: 11494, label: "#133 (3:11:34)" },
      { id: "s2KL075Eyzs", time: 1549, label: "#134 (25:49)" },
      { id: "uffaL0r9-fE", time: 19152, label: "#135 (5:19:12)" },
      { id: "SS-9gLZlsXU", time: 1816, label: "#135-2 (30:17)" },
      { id: "fXflse4WSec", time: 4622, label: "#173 (1:17:02)" },
      { id: "_FlVaRhKN10", time: 17485, label: "#177 (4:51:25)" },
    ],
  },
  {
    name: "Clair Obscur: Expedition 33",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9gam.jpg",
    link: "https://backloggd.com/games/clair-obscur-expedition-33/",
    sessions: [
      { id: "pyofSHPEH7A", time: 9544, label: "#101 (2:39:04)" },
      { id: "6bSzZQJET0E", time: 14947, label: "#102 (4:09:07)" },
      { id: "xv-4xVuWWa4", time: 14278, label: "#103 (3:57:57)" },
    ],
  },
  {
    name: "Persona5: The Phantom X",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9t5k.jpg",
    link: "https://backloggd.com/games/persona5-the-phantom-x--1/",
    sessions: [
      { id: "9a_YanUjBJU", time: 12671, label: "#111 (3:31:11)" },
    ],
  },
  {
    name: "Death Stranding 2: On The Beach",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9ipx.jpg",
    link: "https://backloggd.com/games/death-stranding-2-on-the-beach/",
    sessions: [
      { id: "9a_YanUjBJU", time: 20014, label: "#111 (5:33:35)" },
      { id: "XEpbWR7aGqc", time: 10168, label: "#112 (2:49:28)" },
      { id: "CzP34QaEKyw", time: 6414, label: "#113 (1:46:54)" },
      { id: "194ojRgnBwg", time: 12108, label: "#114 (3:21:48)" },
      { id: "gafmRxBkanA", time: 9644, label: "#115 (2:40:44)" },
      { id: "UuLBwW8iVYg", time: 20488, label: "#116 (5:41:28)" },
      { id: "khBU2csDVME", time: 26934, label: "#117 (7:28:54)" },
      { id: "EuzjGO0L65o", time: 23076, label: "#117-2 (6:24:36)" },
      { id: "9DEfiaahXHQ", time: 13056, label: "#120 (3:37:36)" },
      { id: "P5RSNmSy9oQ", time: 13783, label: "#121 (3:49:43)" },
      { id: "wMQ6tCPQN84", time: 10338, label: "#124 (2:52:18)" },
      { id: "qm7j6vdJWfw", time: 12247, label: "#125 (3:24:07)" },
    ],
  },
  {
    name: "Project Zomboid",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co7kod.jpg",
    link: "https://backloggd.com/games/project-zomboid/",
    sessions: [
      { id: "khBU2csDVME", time: 8737, label: "#117 (2:25:37)" },
      { id: "khBU2csDVME", time: 18674, label: "#117 (5:11:14)" },
      { id: "EuzjGO0L65o", time: 3858, label: "#117-2 (1:04:18)" },
    ],
  },
  {
    name: "Animal Shelter 2",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9736.jpg",
    link: "https://backloggd.com/games/animal-shelter-2/",
    sessions: [
      { id: "H962Icu2v8Y", time: 9730, label: "#118 (2:42:10)" },
    ],
  },
  {
    name: "Aneurism IV",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9jo5.jpg",
    link: "https://backloggd.com/games/aneurism-iv/",
    sessions: [
      { id: "derNOzbiVo4", time: 14029, label: "#119 (3:53:49)" },
      { id: "oIRyclbHlJ4", time: 15229, label: "#119-2 (4:13:49)" },
    ],
  },
  {
    name: "Battlefield 6",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coa5zt.jpg",
    link: "https://backloggd.com/games/battlefield-6/",
    sessions: [
      { id: "3a8FLrK8MLg", time: 10797, label: "#122 (2:59:57)" },
    ],
  },
  {
    name: "No-Skin",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8kle.jpg",
    link: "https://backloggd.com/games/no-skin/",
    sessions: [
      { id: "qm7j6vdJWfw", time: 4468, label: "#125 (1:14:28)" },
      { id: "O2dQChMKqxE", time: 14458, label: "#155 (4:00:58)" },
    ],
  },
  {
    name: "Silent Hill f",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9wy4.jpg",
    link: "https://backloggd.com/games/silent-hill-f/",
    sessions: [
      { id: "bejeUQJxhPw", time: 4908, label: "#127 (1:21:48)" },
      { id: "VVqOUz2exYA", time: 12389, label: "#128 (3:26:29)" },
    ],
  },
  {
    name: "No, I'm Not A Human",
    img: "https://i.ibb.co/qwr54tp/image-1.png",
    link: "https://backloggd.com/games/no-im-not-a-human/",
    sessions: [
      { id: "mQEZLBnjVYY", time: 5302, label: "#129 (1:28:22)" },
      { id: "cyZfFzH8fQA", time: 4128, label: "#131 (1:08:48)" },
      { id: "rBUBc94Pc-s", time: 16299, label: "#132 (4:31:39)" },
    ],
  },
  {
    name: "Decade",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9dl9.jpg",
    link: "https://backloggd.com/games/decade--1/",
    sessions: [
      { id: "mQEZLBnjVYY", time: 10343, label: "#129 (2:52:23)" },
      { id: "X6tQqE8y2Ck", time: 13915, label: "#130 (3:51:55)" },
    ],
  },
  {
    name: "Megabonk",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coagq6.jpg",
    link: "https://backloggd.com/games/megabonk/",
    sessions: [
      { id: "mQEZLBnjVYY", time: 13118, label: "#129 (3:38:38)" },
    ],
  },
  {
    name: "Hades II",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coaknx.jpg",
    link: "https://backloggd.com/games/hades-ii/",
    sessions: [
      { id: "X6tQqE8y2Ck", time: 12576, label: "#130 (3:29:36)" },
    ],
  },
  {
    name: "Vampire: The Masquerade - Bloodlines 2",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coab6r.jpg",
    link: "hhttps://backloggd.com/games/vampire-the-masquerade-bloodlines-2/",
    sessions: [
      { id: "G7G4lrWbQto", time: 20867, label: "#133 (5:47:47)" },
      { id: "WQ0KKJzXeS0", time: 2485, label: "#133-2 (41:25)" },
      { id: "s2KL075Eyzs", time: 8364, label: "#134 (2:19:24)" },
      { id: "uffaL0r9-fE", time: 20070, label: "#135 (5:34:30)" },
      { id: "euyFg7MFnwI", time: 24630, label: "#136 (6:50:30)" },
    ],
  },
  {
    name: "Road to Vostok",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co5dyp.jpg",
    link: "https://backloggd.com/games/road-to-vostok/",
    sessions: [
      { id: "WQ0KKJzXeS0", time: 24052, label: "#133-2 (6:40:52)" },
      { id: "47QlRkM4h_c", time: 15235, label: "#171 (4:13:55)" },
      { id: "EOFa9U7knbU", time: 26814, label: "#172 (7:26:54)" },
      { id: "fXflse4WSec", time: 13674, label: "#173 (3:47:54)" },
      { id: "1zHJtGc147M", time: 16993, label: "#175 (4:43:13)" },
    ],
  },
  {
    name: "ARC Raiders",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9rk1.jpg",
    link: "https://backloggd.com/games/arc-raiders/",
    sessions: [
      { id: "SS-9gLZlsXU", time: 5455, label: "#135-2 (1:30:55)" },
      { id: "8ePWLiGKUqI", time: 1066, label: "#137 (17:46)" },
      { id: "RxV1oEoeI1E", time: 22172, label: "#138 (6:09:32)" },
      { id: "ToJP3pMBJ4Q", time: 1046, label: "#140 (17:26)" },
      { id: "6hdY68VD9RE", time: 7354, label: "#141 (2:02:34)" },
      { id: "XwxoKrT1GtI", time: 17945, label: "#142 (4:59:05)" },
      { id: "C9tnBw8Bfs4", time: 24266, label: "#144 (6:44:26)" },
      { id: "BGUu_pW7f1E", time: 12165, label: "#145 (3:22:45)" },
      { id: "3uqBNFLn7qk", time: 7035, label: "#147 (1:57:17)" },
      { id: "Gclmhdo8LvE", time: 7211, label: "#148 (2:00:11)" },
      { id: "O2dQChMKqxE", time: 24314, label: "#155 (6:45:14)" },
      { id: "Vm5YOXXccjI", time: 35723, label: "#156 (9:55:23)" },
      { id: "kw4YjdiiOwM", time: 16112, label: "#157 (4:28:32)" },
      { id: "5NY_3Qj3NAc", time: 22764, label: "#159 (6:19:24)" },
      { id: "XBqY9Y2MhCM", time: 17040, label: "#160 (4:44:00)" },
      { id: "4t4-KO5UeFE", time: 820, label: "#162 (13:40)" },
      { id: "MvVTJdzu70c", time: 6948, label: "#162-2 (1:55:48)" },
      { id: "bdngCKuXo48", time: 8677, label: "#170 (2:24:37)" },
      { id: "fXflse4WSec", time: 1214, label: "#173 (20:14)" },
    ],
  },
  {
    name: "Dispatch",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co95gb.jpg",
    link: "https://backloggd.com/games/dispatch--3/",
    sessions: [
      { id: "euyFg7MFnwI", time: 1532, label: "#136 (25:32)" },
      { id: "RxV1oEoeI1E", time: 12147, label: "#138 (3:22:27)" },
    ],
  },
  {
    name: "Cronos: The New Dawn",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coaeix.jpg",
    link: "https://backloggd.com/games/cronos-the-new-dawn/",
    sessions: [
      { id: "8ePWLiGKUqI", time: 10739, label: "#137 (2:58:59)" },
      { id: "C9tnBw8Bfs4", time: 11783, label: "#144 (3:16:3)" },
    ],
  },
  {
    name: "R.E.P.O.",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9lxz.jpg",
    link: "https://backloggd.com/games/repo/",
    sessions: [
      { id: "RxV1oEoeI1E", time: 858, label: "#138 (14:18)" },
    ],
  },
  {
    name: "RV There Yet?",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coapnc.jpg",
    link: "https://backloggd.com/games/rv-there-yet--1/",
    sessions: [
      { id: "RxV1oEoeI1E", time: 3452, label: "#138 (57:32)" },
    ],
  },
  {
    name: "Fast Food Simulator",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co8y0o.jpg",
    link: "https://backloggd.com/games/fast-food-simulator--1/",
    sessions: [
      { id: "XwxoKrT1GtI", time: 2965, label: "#142 (49:25)" },
    ],
  },
  {
    name: "Peak",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coat49.jpg",
    link: "https://backloggd.com/games/peak--1/",
    sessions: [
      { id: "XwxoKrT1GtI", time: 12445, label: "#142 (3:27:26)" },
    ],
  },
  {
    name: "Easy Delivery Co.",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9qdg.jpg",
    link: "https://backloggd.com/games/easy-delivery-co/",
    sessions: [
      { id: "cyZfFzH8fQA", time: 25776, label: "#131 (7:09:36)" },
    ],
  },
  {
    name: "My Winter Car",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coawz3.jpg",
    link: "https://backloggd.com/games/my-winter-car/",
    sessions: [
      { id: "9JphuEVaWOc", time: 1699, label: "#152 (28:19)" },
      { id: "bdngCKuXo48", time: 13715, label: "#170 (3:48:35)" },
      { id: "47QlRkM4h_c", time: 20216, label: "#171 (5:36:56)" },
      { id: "EOFa9U7knbU", time: 16277, label: "#172 (4:31:17)" },
    ],
  },
  {
    name: "Crusader Kings III",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co90uu.jpg",
    link: "https://backloggd.com/games/crusader-kings-iii/",
    sessions: [
      { id: "PJIqvoB7QRk", time: 4002, label: "#154 (1:06:42)" },
    ],
  },
  {
    name: "Dingir OS",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coaqpq.jpg",
    link: "https://backloggd.com/games/dingir-os/",
    sessions: [
      { id: "O2dQChMKqxE", time: 20902, label: "#155 (5:48:22)" },
    ],
  },
  {
    name: "Umamusume: Pretty Derby",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coamgf.jpg",
    link: "https://backloggd.com/games/umamusume-pretty-derby/",
    sessions: [
      { id: "O2dQChMKqxE", time: 23723, label: "#155 (6:35:23)" },
      { id: "kw4YjdiiOwM", time: 2160, label: "#157 (36:00)" },
    ],
  },
  {
    name: "The Outer Worlds 2",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co9xx4.jpg",
    link: "https://backloggd.com/games/the-outer-worlds-2/",
    sessions: [
      { id: "O2dQChMKqxE", time: 23960, label: "#155 (6:39:20)" },
    ],
  },
  {
    name: "Apex Legends",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coa93z.jpg",
    link: "https://backloggd.com/games/apex-legends/",
    sessions: [
      { id: "XBqY9Y2MhCM", time: 14160, label: "#160 (3:56:00)" },
    ],
  },
  {
    name: "Marathon",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/cobbf4.jpg",
    link: "https://backloggd.com/games/marathon--2/",
    sessions: [
      { id: "5NY_3Qj3NAc", time: 11021, label: "#159 (3:03:41)" },
      { id: "4t4-KO5UeFE", time: 5987, label: "#162 (1:39:47)" },
      { id: "MvVTJdzu70c", time: 13309, label: "#162-2 (3:41:49)" },
      { id: "ebQqUmNNars", time: 4345, label: "#163 (1:12:25)" },
      { id: "47QlRkM4h_c", time: 10146, label: "#171 (2:49:06)" },
      { id: "EOFa9U7knbU", time: 34369, label: "#172 (9:32:49)" },
      { id: "fXflse4WSec", time: 23830, label: "#173 (6:37:10)" },
    ],
  },
  {
    name: "Esoteric Ebb",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/cobakp.jpg",
    link: "https://backloggd.com/games/esoteric-ebb/",
    sessions: [
      { id: "MvVTJdzu70c", time: 21917, label: "#162-2 (6:05:17)" },
      { id: "0Zmu_CkWHeA", time: 20102, label: "#167 (5:35:02)" },
    ],
  },
  {
    name: "Sahir: Shiv of Memories",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/coanql.jpg",
    link: "https://backloggd.com/games/sahir-shiv-of-memories/",
    sessions: [
      { id: "0Zmu_CkWHeA", time: 11133, label: "#167 (3:05:33)" },
    ],
  },
  {
    name: "Caves of Qud",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/co7eda.jpg",
    link: "https://backloggd.com/games/caves-of-qud/",
    sessions: [
      { id: "8r2y_25lWmc", time: 7470, label: "#168 (2:04:30)" },
    ],
  },
  {
    name: "Data Center",
    img: "https://images.igdb.com/igdb/image/upload/t_cover_big_2x/cobncw.jpg",
    link: "https://backloggd.com/games/data-center--1/",
    sessions: [
      { id: "8r2y_25lWmc", time: 19024, label: "#168 (5:17:04)" },
    ],
  },
];

function App() {
  const [screenState, setScreenState] = useState("intro");
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [isSlidingOut, setIsSlidingOut] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState("");
  const [selectedStartTime, setSelectedStartTime] = useState(0);
  const [videoDetailsKick, setVideoDetailsKick] = useState([]);
  const [videoDetailsTwitch, setVideoDetailsTwitch] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPlatform, setSelectedPlatform] = useState("kick");
  const [kickSortOrder, setKickSortOrder] = useState("episode-asc"); // "default", "episode-asc", "episode-desc"
  const [gameSortOrder, setGameSortOrder] = useState("most-played"); // "most-played", "least-played"
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  const [showBmcPopup, setShowBmcPopup] = useState(false);
  const [expandedGames, setExpandedGames] = useState(new Set()); // Track expanded games by "year-gameName"
  const [expandedYears, setExpandedYears] = useState(new Set()); // Track expanded years
  const [monthlyGamesModal, setMonthlyGamesModal] = useState(null); // { year, month, x, y } or null

  const isMobile = useIsMobile();
  const currentIntroGif = selectedPlatform === "twitch" ? introGif2 : introGif1;

  // Animate scrollbar colors on theme change with smooth transition
  useEffect(() => {
    const styleId = 'scrollbar-theme-transition';
    let existingStyle = document.getElementById(styleId);
    
    if (!existingStyle) {
      existingStyle = document.createElement('style');
      existingStyle.id = styleId;
      document.head.appendChild(existingStyle);
    }

    const kickColors = {
      thumb: '#49cf0654',
      thumbHover: '#64ff278f',
      main: '#64ff27',
      sidebarThumb: '#39a80088',
      sidebarThumbHover: '#39a800cc'
    };
    const twitchColors = {
      thumb: '#9046ff62',
      thumbHover: '#7020dfcc',
      main: '#9146ff',
      sidebarThumb: '#9146ffcc',
      sidebarThumbHover: '#b783ffcc'
    };

    const colors = selectedPlatform === 'kick' ? kickColors : twitchColors;

    // Create keyframes animation for the scrollbar color transition
    const animationName = `scrollbarFade-${selectedPlatform}`;
    existingStyle.textContent = `
      @keyframes ${animationName} {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      .game-list::-webkit-scrollbar-thumb {
        background-color: ${colors.thumb} !important;
      }
      .game-list::-webkit-scrollbar-thumb:hover {
        background-color: ${colors.thumbHover} !important;
      }
      .game-extra > div::-webkit-scrollbar-thumb {
        background-color: ${colors.main} !important;
        border-color: ${colors.main} !important;
      }
      .game-extra > div::-webkit-scrollbar-track {
        border-color: ${colors.main} !important;
      }
      .game-extra > div::-webkit-scrollbar-thumb:hover {
        box-shadow: 0 0 8px ${colors.main} !important;
      }
      .sidebar-body::-webkit-scrollbar-thumb {
        background: ${colors.sidebarThumb} !important;
      }
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: ${colors.sidebarThumbHover} !important;
      }
    `;
  }, [selectedPlatform]);

  const fetchPlaylist = async (playlistId, setFn) => {
    let nextPageToken = "";
    const videoIds = [];
    try {
      do {
        const playlistUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails&playlistId=${playlistId}&maxResults=50&pageToken=${nextPageToken}&key=${API_KEY}`;
        console.log("Fetching playlist:", playlistUrl);
        const res = await fetch(playlistUrl);
        const data = await res.json();
        console.log("Playlist response:", data);
        if (!data.items) {
          console.error("No items in response:", data);
          return;
        }
        const ids = data.items.map((item) => item.contentDetails.videoId);
        videoIds.push(...ids);
        nextPageToken = data.nextPageToken || "";
      } while (nextPageToken);

      const allVideoData = [];
      for (let i = 0; i < videoIds.length; i += 50) {
        const slice = videoIds.slice(i, i + 50).join(",");
        const detailUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet,contentDetails&id=${slice}&key=${API_KEY}`;
        const res = await fetch(detailUrl);
        const data = await res.json();
        allVideoData.push(
          ...data.items.map((item) => ({
            videoId: item.id,
            title: item.snippet.title,
            date: item.snippet.publishedAt.slice(0, 10),
            length: parseDuration(item.contentDetails.duration),
            durationHours: parseIsoDurationToHours(item.contentDetails.duration),
          }))
        );
      }
      setFn(allVideoData);
    } catch (err) {
      console.error("YouTube API hatası:", err);
    }
  };

  useEffect(() => {
    fetchPlaylist(PLAYLIST_ID_KICK, setVideoDetailsKick);
    fetchPlaylist(PLAYLIST_ID_TWITCH, setVideoDetailsTwitch);
  }, []);

  // Update meta tags for Discord embed with video count
  useEffect(() => {
    const totalVideos = videoDetailsKick.length + videoDetailsTwitch.length;
    const description = `Mert Günhan'ın geçmiş kick yayınları\n\nTekrar sayısı: ${totalVideos}`;

    // Update page title
    document.title = "AGABEY YAYINLARI";
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    // Update Open Graph title for Discord
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'AGABEY YAYINLARI');

    // Update Open Graph description for Discord
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', description);
  }, [videoDetailsKick.length, videoDetailsTwitch.length]);

  useEffect(() => {
    if (screenState === "intro") {
      const fadeTimer = setTimeout(() => setIsFadingOut(true), 1500);
      const transitionTimer = setTimeout(() => setScreenState("buttonScreen"), 2000);
      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(transitionTimer);
      };
    }
  }, [screenState]);

  useEffect(() => {
    if (screenState === "buttonScreen") {
      const btnTimer = setTimeout(() => setShowButtons(true), 500);
      const initialLoadTimer = setTimeout(() => setIsInitialLoad(false), 1000);
      return () => {
        clearTimeout(btnTimer);
        clearTimeout(initialLoadTimer);
      };
    }
  }, [screenState]);


  const handleVideoSelection = (videoId, startTime = 0) => {
    setSelectedVideoId(videoId);
    setSelectedStartTime(startTime);
    setIsSlidingOut(true);
    setTimeout(() => {
      setScreenState("main");
      setIsSlidingOut(false);
    }, 1000);
  };

  const handleMenuClick = () => setScreenState("buttonScreen");

  const currentVideos = useMemo(() => {
    let videos = selectedPlatform === "kick" ? videoDetailsKick : videoDetailsTwitch;
    
    // Apply sorting for Kick videos if sort order is not default
    if (selectedPlatform === "kick" && kickSortOrder !== "default") {
      videos = [...videos].sort((a, b) => {
        const infoA = extractEpisodeInfo(a.title);
        const infoB = extractEpisodeInfo(b.title);
        
        // Videos without episode numbers go to the end
        if (infoA === null && infoB === null) return 0;
        if (infoA === null) return 1;
        if (infoB === null) return -1;
        
        // Sort by episode number first
        if (kickSortOrder === "episode-asc") {
          if (infoA.episode !== infoB.episode) {
            return infoB.episode - infoA.episode; // High to low (125, 124, 123...) - "yeniden eskiye"
          }
          // For same episode, more recent part should come first (#162-2 before #162)
          return infoB.part - infoA.part;
        } else {
          if (infoA.episode !== infoB.episode) {
            return infoA.episode - infoB.episode; // Low to high (1, 2, 3...) - "eskiden yeniye"
          }
          return infoA.part - infoB.part;
        }
      });
    }
    
    return videos;
  }, [selectedPlatform, videoDetailsKick, videoDetailsTwitch, kickSortOrder]);

  const filteredGames = useMemo(() => {
    // Count sessions for each game and sort by most played to least played
    const gamesWithSessionCount = games.map((game) => {
      const sessionCount = game.sessions.length;
      return { ...game, sessionCount };
    });
    
    // Sort by session count based on sort order
    const sortedGames = gamesWithSessionCount.sort((a, b) => {
      if (gameSortOrder === "most-played") {
        return b.sessionCount - a.sessionCount; // Descending - most played first
      } else {
        return a.sessionCount - b.sessionCount; // Ascending - least played first
      }
    });
    
    // Apply search filter
    return sortedGames.filter((game) =>
      game.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, gameSortOrder]);

  // Calculate stats by year (only Kick videos)
  const statsByYear = useMemo(() => {
    const allVideos = [...videoDetailsKick]; // Only count Kick videos, exclude Twitch
    const yearStats = {};

    // Create a map of videoId to year for quick lookup
    const videoYearMap = {};
    allVideos.forEach((video) => {
      const year = video.date ? video.date.split('-')[0] : null;
      const month = video.date ? video.date.split('-')[1] : null;
      if (year) {
        videoYearMap[video.videoId] = { year, month };
        if (!yearStats[year]) {
          yearStats[year] = {
            streamCount: 0,
            streamHours: 0,
            gameCounts: {},
            monthlyStats: {
              '01': { count: 0, hours: 0, gameCounts: {} },
              '02': { count: 0, hours: 0, gameCounts: {} },
              '03': { count: 0, hours: 0, gameCounts: {} },
              '04': { count: 0, hours: 0, gameCounts: {} },
              '05': { count: 0, hours: 0, gameCounts: {} },
              '06': { count: 0, hours: 0, gameCounts: {} },
              '07': { count: 0, hours: 0, gameCounts: {} },
              '08': { count: 0, hours: 0, gameCounts: {} },
              '09': { count: 0, hours: 0, gameCounts: {} },
              '10': { count: 0, hours: 0, gameCounts: {} },
              '11': { count: 0, hours: 0, gameCounts: {} },
              '12': { count: 0, hours: 0, gameCounts: {} },
            },
          };
        }
        yearStats[year].streamCount++;
        yearStats[year].streamHours += video.durationHours || 0;
        if (month && yearStats[year].monthlyStats[month]) {
          yearStats[year].monthlyStats[month].count++;
          yearStats[year].monthlyStats[month].hours += video.durationHours || 0;
        }
      }
    });

    // Count games per year and per month by matching video IDs to game sessions
    games.forEach((game) => {
      game.sessions.forEach((session) => {
        const videoData = videoYearMap[session.id];
        const year = videoData?.year;
        const month = videoData?.month;
        if (year && yearStats[year]) {
          // Count for year
          if (!yearStats[year].gameCounts[game.name]) {
            yearStats[year].gameCounts[game.name] = 0;
          }
          yearStats[year].gameCounts[game.name]++;
          
          // Count for month
          if (month && yearStats[year].monthlyStats[month]) {
            if (!yearStats[year].monthlyStats[month].gameCounts[game.name]) {
              yearStats[year].monthlyStats[month].gameCounts[game.name] = 0;
            }
            yearStats[year].monthlyStats[month].gameCounts[game.name]++;
          }
        }
      });
    });

    // Convert to array and get top 3 games for each year with full game data
    const statsArray = Object.entries(yearStats)
      .map(([year, stats]) => {
        const topGames = Object.entries(stats.gameCounts)
          .map(([gameName, count]) => {
            // Find the full game object
            const gameObj = games.find(g => g.name === gameName);
            // Filter sessions for this year
            const yearSessions = gameObj ? gameObj.sessions.filter(session => {
              const videoData = videoYearMap[session.id];
              return videoData?.year === year;
            }) : [];
            
            return { 
              gameName, 
              count,
              game: gameObj,
              sessions: yearSessions
            };
          })
          .sort((a, b) => b.count - a.count)
          .slice(0, 3);
        
        return {
          year,
          streamCount: stats.streamCount,
          streamHours: Math.round(stats.streamHours * 100) / 100, // Round to 2 decimal places
          topGames,
          monthlyStats: stats.monthlyStats,
        };
      })
      .sort((a, b) => b.year.localeCompare(a.year)); // Sort by year descending

    // Calculate total stats
    const totalStreamCount = statsArray.reduce((sum, stat) => sum + stat.streamCount, 0);
    const totalStreamHours = statsArray.reduce((sum, stat) => sum + stat.streamHours, 0);
    const archiveSizeGB = totalStreamHours * 3.7;

    const totalStats = {
      year: 'Bütün Zamanlar',
      streamCount: totalStreamCount,
      streamHours: Math.round(totalStreamHours * 100) / 100,
      archiveSizeGB: Math.round(archiveSizeGB * 100) / 100,
      topGames: [],
      monthlyStats: {},
    };

    return [totalStats, ...statsArray];
  }, [videoDetailsKick]);

  return (
    <div className={`App ${selectedPlatform}-theme`}>
      {screenState === "intro" && (
        <div className={`intro-screen ${isFadingOut ? "fade-out" : ""}`}>
          <img src={currentIntroGif} alt="Intro" className={`shared-gif ${isFadingOut ? "low-opacity" : ""}`} />
        </div>
      )}

      {screenState === "buttonScreen" && (
        <div className={`button-screen ${isSlidingOut ? "slide-left" : ""}`}>
          <img src={currentIntroGif} alt="Background" className="shared-gif low-opacity" />

          <div className="search-and-donate-container">
            <div className="game-search-wrapper">
              <div className="game-search-bar">
                <input
                  type="text"
                  placeholder={isMobile ? `Oyun ara... (${games.length} total)` : `Oyun ara... (${games.length} total)`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div 
                className="game-sort-icon"
                onClick={() => {
                  setGameSortOrder(gameSortOrder === "most-played" ? "least-played" : "most-played");
                }}
              >
                {gameSortOrder === "most-played" ? "En çok oynanan ↓" : "En az oynanan ↑"}
              </div>
            </div>
            
            <div className="action-buttons">
              <button 
                onClick={() => setShowStatsModal(true)}
                className="bug-report-button"
                title="İstatistikler"
              >
                📊
              </button>
              <button 
                onClick={() => setShowContactModal(true)}
                className="bug-report-button"
                title="Hata bildir"
              >
                💬
              </button>
              <button
                className="bug-report-button bmc-button"
                title="Buy me a coffee"
                onClick={() => setShowBmcPopup((prev) => !prev)}
              >
                ☕
              </button>
              {showBmcPopup && (
                <div className="bmc-dropdown" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="bmc-dropdown-close"
                    onClick={() => setShowBmcPopup(false)}
                    aria-label="Close"
                  >
                    ×
                  </button>
                  <iframe
                    src="https://www.buymeacoffee.com/widget/page/soeth?description=Support%20me%20on%20Buy%20me%20a%20coffee!"
                    title="Buy Me a Coffee"
                    className="bmc-iframe"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="game-list">
            {filteredGames.map((game, index) => (
              <div key={index} className="game-item">
                <a href={game.link} target="_blank" rel="noopener noreferrer">
                  <img src={game.img} alt={game.name} className="game-poster" loading="lazy" />
                </a>
                <div className="game-info">
                  <div className="game-name">{game.name}</div>
                  <div className="game-extra">
                    {isMobile ? `Yayınlar(${game.sessions.length}):` : `Oynandığı yayınlar(${game.sessions.length}):`}
                    <div>
                      {game.sessions.map((session, i) => (
                        <button
                          key={i}
                          className="video-link-button"
                          onClick={() => handleVideoSelection(session.id, session.time)}
                        >
                          {session.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="platform-buttons">
            <button
              className={selectedPlatform === "kick" ? "active" : ""}
              onClick={() => setSelectedPlatform("kick")}
              title="Kick"
            >
              <img src={kickLogo} alt="Kick" className="platform-icon" />
            </button>
            <button
              className={selectedPlatform === "twitch" ? "active twitch" : "twitch"}
              onClick={() => setSelectedPlatform("twitch")}
              title="Twitch"
            >
              <img src={twitchLogo} alt="Twitch" className="platform-icon" />
            </button>
            
            
            <div style={{ color: "var(--color-text-muted)", marginLeft: "0px", marginTop: "5px", fontSize: isMobile ? "10px" : "12px" }}>
              {selectedPlatform === "kick"
                ? `Kick: ${videoDetailsKick.length}`
                : `Twitch: ${videoDetailsTwitch.length}`}
            </div>
          </div>

          <div className="button-grid-container">
            {/* Sort icon for Kick videos */}
            {selectedPlatform === "kick" && (
              <div className={`sort-icon-container ${isInitialLoad ? 'sort-animate' : 'sort-no-animate'}`}>
                <div 
                  className="sort-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (kickSortOrder === "default") {
                      setKickSortOrder("episode-asc");
                    } else {
                      setKickSortOrder("default");
                    }
                  }}
                >
                  {kickSortOrder === "default" && "yeniden eskiye ↑"}
                  {kickSortOrder === "episode-asc" && "yeniden eskiye ↓"}
                </div>
              </div>
            )}
            
            <div className="button-grid" key={`${selectedPlatform}-${kickSortOrder}`}>
              {currentVideos.map((video) => (
                <button
                  key={video.videoId}
                  className={`grid-button ${showButtons ? "visible" : ""}`}
                  onClick={() => handleVideoSelection(video.videoId)}
                  title={video.title}
                >
                  <div className="button-thumbnail">
                    <img
                      src={`https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
                      alt={video.title}
                      className="thumbnail-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="button-info">
                    <div className="button-title">
                      {isMobile && video.title.length > 40 
                        ? `${video.title.substring(0, 40)}...` 
                        : video.title}
                    </div>
                    <div className="button-date">{video.date}</div>
                    <div className="button-length">{video.length}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {screenState === "main" && (
        <>
          {!isMobile && (
            <Sidebar
              onMenuClick={handleMenuClick}
              featuredVideos={currentVideos}
              onVideoSelect={handleVideoSelection}
              selectedVideoId={selectedVideoId}
              selectedPlatform={selectedPlatform}
              setSelectedPlatform={setSelectedPlatform}
              kickSortOrder={kickSortOrder}
              setKickSortOrder={setKickSortOrder}
            />
          )}
          <div className="main-content">
            <div className="video-container">
              <VideoPlayer videoId={selectedVideoId} startTime={selectedStartTime} />
            </div>
            {isMobile && (
              <button 
                onClick={handleMenuClick}
                className="mobile-menu-button"
              >
                Ana Menüye Dön
              </button>
            )}
          </div>
        </>
      )}

      {/* Monthly Games Popup */}
      {monthlyGamesModal && (() => {
        const yearStat = statsByYear.find(s => s.year === monthlyGamesModal.year);
        const monthData = yearStat?.monthlyStats[monthlyGamesModal.month];
        const monthNames = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
        const monthName = monthNames[parseInt(monthlyGamesModal.month) - 1];
        const monthlyGames = monthData?.gameCounts ? Object.entries(monthData.gameCounts)
          .map(([gameName, count]) => {
            const gameObj = games.find(g => g.name === gameName);
            const monthSessions = gameObj ? gameObj.sessions.filter(session => {
              const allVideos = [...videoDetailsKick];
              const videoData = allVideos.find(v => v.videoId === session.id);
              if (!videoData) return false;
              const videoYear = videoData.date?.split('-')[0];
              const videoMonth = videoData.date?.split('-')[1];
              return videoYear === monthlyGamesModal.year && videoMonth === monthlyGamesModal.month;
            }) : [];
            return { gameName, count, game: gameObj, sessions: monthSessions };
          })
          .sort((a, b) => b.count - a.count) : [];
        
        // Calculate position near cursor, but keep within viewport
        const popupWidth = 350;
        const popupHeight = 400;
        const padding = 20;
        
        // Calculate X position (center on cursor, but keep within viewport)
        let x = monthlyGamesModal.x - popupWidth / 2;
        if (x < padding) x = padding;
        if (x + popupWidth > window.innerWidth - padding) {
          x = window.innerWidth - popupWidth - padding;
        }
        
        // Calculate Y position (below cursor, but keep within viewport)
        let y = monthlyGamesModal.y + 20;
        if (y + popupHeight > window.innerHeight - padding) {
          // If it would go below, try above cursor
          y = monthlyGamesModal.y - popupHeight - 20;
          // If still goes above, position at bottom of viewport
          if (y < padding) {
            y = window.innerHeight - popupHeight - padding;
          }
        }
        
        return (
          <>
            <div className="monthly-games-overlay" onClick={() => setMonthlyGamesModal(null)}></div>
            <div 
              className="monthly-games-popup" 
              onClick={(e) => e.stopPropagation()}
              style={{
                left: `${Math.max(20, x)}px`,
                top: `${Math.max(20, y)}px`
              }}
            >
              <div className="monthly-games-header">
                <button 
                  className="monthly-games-close"
                  onClick={() => setMonthlyGamesModal(null)}
                >
                  ×
                </button>
                <h4>{monthName} {monthlyGamesModal.year}</h4>
              </div>
              <div className="monthly-games-content">
                {monthlyGames.length === 0 ? (
                  <div className="stats-empty">Bu ay oynanan oyun yok</div>
                ) : (
                  <div className="monthly-games-list">
                    {monthlyGames.map((gameData, idx) => (
                      <div key={idx} className="monthly-game-item">
                        {gameData.game && (
                          <>
                            <img 
                              src={gameData.game.img} 
                              alt={gameData.gameName}
                              className="monthly-game-image"
                              loading="lazy"
                            />
                            <div className="monthly-game-info">
                              <div className="monthly-game-name">{gameData.gameName}</div>
                              <div className="monthly-game-count">{gameData.count} yayın</div>
                              {gameData.sessions.length > 0 && (
                                <div className="monthly-game-sessions">
                                  {gameData.sessions.map((session, sessionIdx) => (
                                    <button
                                      key={sessionIdx}
                                      className="stats-session-button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleVideoSelection(session.id, session.time);
                                        setMonthlyGamesModal(null);
                                        setShowStatsModal(false);
                                      }}
                                    >
                                      {session.label}
                                    </button>
                                  ))}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </>
        );
      })()}

      {/* Stats Modal */}
      {showStatsModal && (
        <div className="contact-modal-overlay" onClick={() => {
          setShowStatsModal(false);
          setExpandedGames(new Set());
          setExpandedYears(new Set());
          setMonthlyGamesModal(null);
        }}>
          <div className="stats-modal" onClick={(e) => e.stopPropagation()}>
            <button 
              className="contact-modal-close"
              onClick={() => {
                setShowStatsModal(false);
                setExpandedGames(new Set());
                setExpandedYears(new Set());
              }}
            >
              ×
            </button>
            <h3>İstatistikler</h3>
            <div className="stats-content">
              {statsByYear.length === 0 ? (
                <div className="stats-empty">Henüz veri yok</div>
              ) : (
                statsByYear.map((yearStat) => {
                  if (yearStat.year === 'Bütün Zamanlar') {
                    return (
                      <div key={yearStat.year} className="stats-year-section">
                        <div className="stats-year-header">
                          <span className="stats-year-title">
                            {yearStat.year}
                          </span>
                        </div>
                        <div className="stats-year-info">
                          <div className="stats-item">
                            <span className="stats-label">Yayın Sayısı:</span>
                            <span className="stats-value">{yearStat.streamCount}</span>
                          </div>
                          <div className="stats-item">
                            <span className="stats-label">Toplam Saat:</span>
                            <span className="stats-value">{yearStat.streamHours.toFixed(2)} saat</span>
                          </div>
                          <div className="stats-item">
                            <span className="stats-label">Arşiv Boyutu:</span>
                            <span className="stats-value">{yearStat.archiveSizeGB.toFixed(2)} GB</span>
                          </div>
                        </div>
                      </div>
                    );
                  }

                  const isYearExpanded = expandedYears.has(yearStat.year);
                  
                  return (
                    <div key={yearStat.year} className="stats-year-section">
                      <div 
                        className="stats-year-header"
                        onClick={() => {
                          const newExpanded = new Set(expandedYears);
                          if (isYearExpanded) {
                            newExpanded.delete(yearStat.year);
                          } else {
                            newExpanded.add(yearStat.year);
                          }
                          setExpandedYears(newExpanded);
                        }}
                      >
                        <span className="stats-year-expand">{isYearExpanded ? '▼' : '▶'}</span>
                        <span className="stats-year-title">
                          {yearStat.year}
                          {yearStat.year === '2024' && (
                            <span className="stats-year-note"> (37 Yayın eksik)</span>
                          )}
                        </span>
                      </div>
                      {isYearExpanded && (
                        <div className="stats-year-info">
                          <div className="stats-item">
                            <span className="stats-label">Yayın Sayısı:</span>
                            <span className="stats-value">{yearStat.streamCount}</span>
                          </div>
                          <div className="stats-item">
                            <span className="stats-label">Toplam Saat:</span>
                            <span className="stats-value">{yearStat.streamHours.toFixed(2)} saat</span>
                          </div>
                          <div className="stats-monthly-chart">
                            <div className="stats-label" style={{ marginBottom: '12px' }}>Aylık Yayın Sayısı:</div>
                            <div className="stats-chart-container">
                              {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month) => {
                                const data = yearStat.monthlyStats[month];
                                const monthNames = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
                                const monthName = monthNames[parseInt(month) - 1];
                                const maxCount = Math.max(...Object.values(yearStat.monthlyStats).map(m => m.count));
                                const heightPercent = maxCount > 0 ? (data.count / maxCount) * 100 : 0;
                                
                                return (
                                  <div key={month} className="stats-chart-bar-wrapper">
                                    <div className="stats-chart-bar-container">
                                      <div 
                                        className="stats-chart-bar"
                                        style={{ height: `${heightPercent}%` }}
                                        title={`${monthName}: ${data.count} yayın, ${data.hours.toFixed(1)} saat`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (data.count > 0) {
                                            setMonthlyGamesModal({ 
                                              year: yearStat.year, 
                                              month,
                                              x: e.clientX,
                                              y: e.clientY
                                            });
                                          }
                                        }}
                                      >
                                        {data.count > 0 && (
                                          <span className="stats-chart-bar-value">{data.count}</span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="stats-chart-month-label">{monthName}</div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          {yearStat.topGames.length > 0 && (
                            <div className="stats-top-games">
                              <div className="stats-label">En Çok Oynanan 3 Oyun:</div>
                              <div className="stats-games-list">
                                {yearStat.topGames.map((game, idx) => {
                                  const gameKey = `${yearStat.year}-${game.gameName}`;
                                  const isExpanded = expandedGames.has(gameKey);
                                  
                                  return (
                                    <div key={idx} className="stats-game-container">
                                      <div 
                                        className="stats-game-item"
                                        onClick={() => {
                                          const newExpanded = new Set(expandedGames);
                                          if (isExpanded) {
                                            newExpanded.delete(gameKey);
                                          } else {
                                            newExpanded.add(gameKey);
                                          }
                                          setExpandedGames(newExpanded);
                                        }}
                                      >
                                        <span className="stats-game-rank">{idx + 1}.</span>
                                        <span className="stats-game-name">{game.gameName}</span>
                                        <span className="stats-game-count">({game.count} yayın)</span>
                                        <span className="stats-game-expand">{isExpanded ? '▼' : '▶'}</span>
                                      </div>
                                      {isExpanded && game.game && (
                                        <div className="stats-game-expanded">
                                          <img 
                                            src={game.game.img} 
                                            alt={game.gameName}
                                            className="stats-game-image"
                                            loading="lazy"
                                          />
                                          {game.sessions.length > 0 && (
                                            <div className="stats-game-sessions">
                                              <div className="stats-sessions-label">Yayınlar:</div>
                                              <div className="stats-sessions-buttons">
                                                {game.sessions.map((session, sessionIdx) => (
                                                  <button
                                                    key={sessionIdx}
                                                    className="stats-session-button"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleVideoSelection(session.id, session.time);
                                                      setShowStatsModal(false);
                                                    }}
                                                  >
                                                    {session.label}
                                                  </button>
                                                ))}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {showContactModal && (
        <div className="contact-modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
            <button 
              className="contact-modal-close"
              onClick={() => setShowContactModal(false)}
            >
              ×
            </button>
            <h3>İletişim - Hata Bildir</h3>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-label">Discord:</span>
                <span className="contact-value">krayb</span>
              </div>
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <span className="contact-value">kraybwired@gmail.com</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;